import React from 'react';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import classes from '../pages/HomePage.module.css';

import starsAnimation from '../animations/starsAnimation.json';
import gridAnimation from '../animations/gridAnimation.json';
import wordAnimation from '../animations/guessWordAnimation.json';

/**
 * The promo card used for Guess the Word / X-O / Ludo.
 *
 * `mainAnimation` defaults to the word animation so existing cards keep the
 * look they have now — pass a different one per game as the assets land.
 */
const GameCard = ({ heading, subText, to, mainAnimation = wordAnimation, buttonLabel = 'Play Now' }) => {
    const navigate = useNavigate();

    return (
        <div className={classes.word_game_container}>
            <div className={classes.word_game_sub_container}>
                <Lottie animationData={starsAnimation} loop autoPlay className={classes.animation_stars} />
            </div>

            <div className={classes.grid_animation_container}>
                <Lottie animationData={gridAnimation} loop autoPlay className={classes.grid_animation} />
            </div>

            <div className={classes.photo_container}>
                <Lottie animationData={mainAnimation} loop autoPlay className={classes.photo} />
            </div>

            <div className={classes.word_game_content}>
                <h1 className={classes.word_game_heading}>{heading}</h1>
                <p className={classes.word_game_text}>{subText}</p>
                <button type="button" className={classes.word_play_btn} onClick={() => navigate(to)}>
                    {buttonLabel}
                </button>
            </div>
        </div>
    );
};

export default GameCard;